import fr from "./fr.json";
import de from "./de.json";
import it from "./it.json";
import pt from "./pt.json";
import ru from "./ru.json";
import tr from "./tr.json";
import zh from "./zh.json";
import ja from "./ja.json";
import hi from "./hi.json";
export default { fr, de, it, pt, ru, tr, zh, ja, hi };
